import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '@/components/Header'
import HeroSection from '@/components/HeroSection'
import AboutSection from '@/components/AboutSection'
import ServicesSection from '@/components/ServicesSection'
import PortfolioSection from '@/components/PortfolioSection'
import TestimonialsSection from '@/components/TestimonialsSection'
import PartnersSection from '@/components/PartnersSection'
import FeaturedBlogsSection from '@/components/FeaturedBlogsSection'
import ContactSection from '@/components/ContactSection'
import ChatbotPopup from '@/components/ChatbotPopup'
import Footer from '@/components/Footer'

export default function HomePage({ language, setLanguage, theme, setTheme }) {
  const location = useLocation()

  useEffect(() => {
    if (!location.hash) return
    const el = document.getElementById(location.hash.slice(1))
    if (!el) return
    const timer = window.setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 80)
    return () => window.clearTimeout(timer)
  }, [location])

  return (
    <div className="bg-background text-foreground transition-colors duration-300">
      <Header
        language={language}
        toggleLanguage={() => setLanguage(language === 'en' ? 'am' : 'en')}
        isDarkMode={theme === 'dark'}
        toggleDarkMode={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      />
      <main>
        <HeroSection language={language} />
        <AboutSection language={language} />
        <ServicesSection language={language} />
        <PortfolioSection language={language} />
        <FeaturedBlogsSection language={language} />
        <TestimonialsSection language={language} />
        <PartnersSection language={language} />
        <ContactSection language={language} />
      </main>
      <Footer language={language} />
      <ChatbotPopup language={language} />
    </div>
  )
}
